import React from 'react'
import MedicineSuccess from '../Components/MyMedicineSuccess/MedicineSuccess'
const MyMedicineSuccessView = () => {
  return (
    <div>
        <MedicineSuccess/>
    </div>
  )
}

export default MyMedicineSuccessView